// This creates convenience store-based functions
var store;

// NOTE: This creates functions that can read from the store directly. This is useful
// for things like server-side embedded info. Before creating new readers, please check:
// - The normal mechanism to make state accesible is through binding in container
//   components via react-redux
// - Feature toggles go to ./features.js instead

// PLEASE ALSO NOTE: This component can also be used from components that have no store,
// yet. This functionality will be removed when all components have access to the store.
// It requires a `window.fakeStore` variable

export function syncInfoWithStore(newStore) {
  store = newStore;
  return true;
}

function getState() {
  return store ? store.getState() : window.fakeStore;
}

export function account(field) {
  return getState().app.account[field];
}

export function info(field) {
  return getState().app.info[field];
}

// This is a simple i18n accessor shorthand to retrieve i18n from the redux store
// It's a different mechanism from react-intl, but uses the same locale meassage data
// If we like it better, we can drop react-intl message replacing (and only use
// its locale formatting)
export function intl(key) {
  return store.getState().i18n[key] || key;
}

export function hasSellerAccount() {
  return account("pricingTier") === "seller";
}

export function hasFreeAccount() {
  return account("pricingTier") === "free";
}

export function hasFreeLockedAccount() {
  return account("pricingTier") === "freeLocked";
}
